export class DynamicCategoryListBindingBehavior {
  bind(binding, source, typeId) {
    binding.originalUpdateTarget = binding.updateTarget;
    binding.updateTarget = allCategoriesOnInstrument => {
      const categoryOnInstrumentOfCorrectType = allCategoriesOnInstrument.find((element) => {
        return element.securitiesCategoryType.id === typeId;
      });

      if (binding.originalUpdateTarget !== undefined && categoryOnInstrumentOfCorrectType != null) {
        binding.originalUpdateTarget(categoryOnInstrumentOfCorrectType);
      }
    };
  }

  unbind(binding) {
    binding.updateTarget = binding.originalUpdateTarget;
    binding.originalUpdateTarget = null;
  }
}
